import React from 'react';
import { useStateContext } from '../../../../context/ContextProvider';
import ColorLandingPage from '../../../LandingPages/ColorLandingPage';

function AziziVeniceApartment({
    language
}) {
    const color = "orange";

    const images = [
        "/assets/images/projects/azizi-venice/1.webp",
        "/assets/images/projects/azizi-venice/2.webp",
        "/assets/images/projects/azizi-venice/3.webp",
        "/assets/images/projects/azizi-venice/4.webp"
    ];

    const poster = "/assets/images/projects/azizi-venice/poster.jpg";
    // const webm = "/assets/images/projects/azizi-venice/hero.webm";
    const video = "/assets/images/projects/azizi-venice/azizi-venice.mp4";

    const {
        langs,
        langCode,
        userInfo,
        HIKALRE_URL,
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const isUAE = userInfo?.countryName == "United Arab Emirates";
    const isUSA = userInfo?.countryName == "United States";
    const isCanada = userInfo?.countryName == "Canada";

    const Heading = () => {
        return (
            <>
                {language == "ar" ? (
                    <h1 className="text-center text-xl lg:text-2xl font-bold leading-relaxed">
                        عرض خاص لفترة محدودة:
                        <br />
                        <span className="text-2xl text-orange-200 neon-orange">
                            وفر أكثر من 77 ألف درهم.. وامتلك شقتك دقائق من مطار آل مكتوم
                        </span>
                        <br />
                        بـ 10% دفعة أولى فقط.. احجز وحدتك الحين
                    </h1>
                ) : (
                    <h1 className="font-bold text-center text-xl leading-relaxed">
                        Limited-Time Offer
                        <br />
                        <span className="text-2xl text-orange-200 neon-orange">
                            Save over AED 77,000 and own your apartment just minutes from Al Maktoum International Airport.
                        </span>
                        <br />
                        Reserve your unit with just a 10% down payment.

                    </h1>
                )}

            </>
        );
    }

    const gridDetails = [
        {
            "topic": "أنواع الوحدات",
            "text": "استوديو 3,2,1 غرفة",
        },
        {
            "topic": "الأسعار تبدأ من",
            "text": isUAE ? "655,000 درهم" : "180 ألف دولار",
        },
        {
            "topic": "أقساط شهرية",
            "text": isUAE ? "6600 درهم" : "1800 دولار",
        },
    ];

    const imageDetails = {
        "title": "✨ عرض حصري لفترة محدودة ✨",
        "desc": "احجز وحدتك الآن واستمتع بمطبخ مجهز بالكامل بجميع الأجهزة الكهربائية من ماركة Siemens الألمانية"
    };

    return (
        <>
            <ColorLandingPage
                color={color}
                // language={language}
                langToggle={{
                    en: "/azizi/venice",
                    ar: "/azizi/venice/ar",
                }}
                poster={poster}
                video={video}
                images={images}
                heading={<Heading />}
                // gridDetails={gridDetails}
                // imageDetails={imageDetails}
                displayAmenity={false}
                displayVisa={false}
                base_url={HIKALRE_URL}
                projectName={"Venice"}
                developer="Azizi"
                project="Venice"
                leadType="Apartment"
                language={language === "ar" ? "Arabic" : "English"}
                enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms"]}
                // assignedToManager={language == "fa" ? 120 : null}
                // assignedToSales={language == "fa" ? 518 : null}
                contactTime={isUSA || isCanada ? true : false}
                otpCode={101}
            />
        </>
    );
}

export default AziziVeniceApartment;
